import axios from 'axios';
import md5 from 'js-md5';

const service = axios.create({
  baseURL:
    process.env.NODE_ENV === 'development'
      ? process.env.VUE_APP_BASE_API
      : window.location.origin,
  timeout: 6000,
});

service.interceptors.request.use((config) => {
  const timestamp = Math.round(Date.now() / 1000);
  if (config.data) {
    config.data.timestamp = timestamp;
  }
  const obj = Object.keys(config.data).sort();
  const params = config.data;
  const arr = [];
  obj.forEach((v) => {
    if (v !== 'uuid') {
      arr.push(`${v}=${params[v]}`);
    }
  });
  const paramsString = arr.join('');
  config.headers['x-sign'] = md5(
    `${paramsString}${process.env.VUE_APP_BASE_KEY}`
  );

  return config;
});

service.interceptors.response.use((response) => {
  let result = response.data;
  return result;
});
export default service;
